import React from 'react';
import FormSignup from '../components/Form-Signup';


const Join = () => {
   return (
      <div className='Join'>
         <h1>Join in</h1>
         <FormSignup />
      </div>
   );
};

export default Join;